import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export const PostOrdersAdmin = () => {
  const [orders, setOrders] = useState([]);
  const [sites, setSites] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ site_id: "", title: "", body: "" });

  const load = useCallback(async () => {
    const r = await api.get("/post-orders");
    setOrders(r.data);
  }, []);

  useEffect(() => {
    load();
    api.get("/sites").then(r => setSites(r.data));
  }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/post-orders", form);
      toast.success("Post order published");
      setOpen(false);
      load();
    } catch { toast.error("Failed"); }
  };

  const siteName = (id) => sites.find(s => s.id === id)?.name || id;

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div className="text-muted" style={{ fontSize: 14 }}>{orders.length} post orders</div>
        <button className="btn-primary inline-flex items-center gap-2" onClick={() => setOpen(true)} data-testid="add-po">
          <Plus size={14} /> New post order
        </button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {orders.map(o => (
          <div key={o.id} className="s-card" data-testid={`po-${o.id}`}>
            <div className="flex justify-between items-start">
              <div className="h-section">{o.title}</div>
              <span className="badge badge-neutral mono">v{o.version}</span>
            </div>
            <div className="text-muted" style={{ fontSize: 12, margin: "4px 0 12px" }}>{siteName(o.site_id)}</div>
            <div style={{ fontSize: 14, lineHeight: 1.6, color: "#fff" }}>{o.body}</div>
            <div className="text-muted" style={{ fontSize: 11, marginTop: 12 }}>By {o.author}</div>
          </div>
        ))}
      </div>

      {open && (
        <div onClick={() => setOpen(false)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex",
          alignItems: "center", justifyContent: "center", zIndex: 100,
        }}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="s-card" style={{ width: 480, maxWidth: "90vw" }}>
            <div className="h-section mb-4">New post order</div>
            <label className="text-muted" style={{ fontSize: 12 }}>Site</label>
            <select required value={form.site_id} onChange={(e) => setForm({...form, site_id: e.target.value})} className="s-input mt-1 mb-3">
              <option value="">Select...</option>
              {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
            <label className="text-muted" style={{ fontSize: 12 }}>Title</label>
            <input required value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} className="s-input mt-1 mb-3" />
            <label className="text-muted" style={{ fontSize: 12 }}>Instructions</label>
            <textarea required rows={6} value={form.body} onChange={(e) => setForm({...form, body: e.target.value})} className="s-input mt-1 mb-4" />
            <button type="submit" className="btn-primary w-full">Publish</button>
          </form>
        </div>
      )}
    </div>
  );
};
